import { CommonModule } from '@angular/common';

import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { MomentModule } from 'ngx-moment';
import { MomentDisplayComponent } from './moment-display.component';

@NgModule({
  imports: [CommonModule, IonicModule, MomentModule],
  declarations: [MomentDisplayComponent],
  exports: [MomentDisplayComponent],
})
export class MomentDisplayModule {}
